import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const LoggedOutLinks = ({ profileLink }: { profileLink: string }) => {
    const { t } = useGranite();

    return (
        <Anchor
            color={"link"}
            className={cn("tw:block tw:w-full tw:text-left tw:py-2 tw:px-4")}
            href={profileLink}
        >
            {t("sideBar.action.link.login")}
        </Anchor>
    );
};
